import { Breadcrumb as BreadcrumbT } from "../../types/breadcrumb";
import { removeGUID } from "../../utils/removeGUID";

export const format = (title: string, removeFormat: boolean) => {
  if (!title) return;

  //if breadcrumb includes a GUID, remove it
  title = removeGUID(title);

  if (
    title.toLowerCase() === "non-runner" ||
    title.toLowerCase() === "non-runners"
  )
    return title;

  if (title.includes("-")) return title.split("-").join(" ").capitalize();

  return removeFormat ? title : title.capitalize();
};

// produces the structured data for the breadcrumbs
export const breadcrumbStructuredData = (breadcrumbs: BreadcrumbT[]) => {
  return {
    itemListElement: breadcrumbs.map((crumb: BreadcrumbT, i: number) => {
      let origin = window.location.origin;
      const fullUrl = window.location.href;

      let url = fullUrl
        .split("/")
        .slice(0, 3 + i)
        .join("/");

      const listItem = {
        "@type": "ListItem",
        position: i + 1,
        name: crumb?.label,
      };

      listItem["item"] = crumb.urlOverride
        ? `${origin}${crumb.urlOverride}`
        : url;

      return listItem;
    }),
  };
};
